class UserManagedDataModel {
  skills;
  agentGroups;
  users;

  constructor(options) {
    this.users = options.users;
    this.skills = options.skills;
    this.agentGroups = options.agentGroups;
  }
}

export default UserManagedDataModel;
